import Vue from 'vue';
import Router from 'vue-router';
import home from './views/Home.vue';
// import notice from './views/Aviso.vue';
import PropietCondomino from './views/PropietCondomino.vue';
import datagrid from './views/DataGrid.vue';
import administraciones from './views/Administraciones.vue';
import condominiosSelector from './views/CondominiosSelector.vue';
import condominio from './views/Condominio.vue';
import conceptos from './views/Conceptos.vue';
import recibos from './views/Recibos.vue';
import persistentes from './views/Persistentes.vue';
import user from './views/User.vue';
import cuentas from './views/CuentasBanco.vue';
import contables from './views/CuentasContables.vue';
import unidades from './views/Unidades.vue';
import login from '@/components/Login.vue';
import series from './views/Series.vue';
import loteRecibos from './views/LoteRecibos.vue';
import cobros from './views/Cobros.vue';
import noringresos from './views/IngresosNoReconocidos.vue';
import pagos from './views/Pagos.vue';
import proveedores from './views/Proveedores.vue';
import egreso from './views/Egreso.vue';
import { component } from 'vue/types/umd';
import generar from './views/GenerarQR.vue';

// import login from '@/components/Login2.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
     {
       path: '/',
       name: 'home',
       // component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
       component: login,
     },
    // {
    //   path: '/Notice',
    //   name: 'notice',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   // component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    //   component: notice,
    // },
    {
      path: '/PropietCondomino',
      name: 'propietCondomino',
      // component: () => import(/* webpackChunkName: "about" */ './views/Panda.vue'),
      component: PropietCondomino,
      props: true,
    },
    {
      path: '/grid',
      name: 'grid',
      // component: () => import(/* webpackChunkName: "about" */ './views/Panda.vue'),
      component: datagrid,
    },
    {
        path: '/login',
        name: 'login',
        // component: () => import(/* webpackChunkName: "about" */ './views/Administraciones.vue'),
        component: login,
        // props: true,
    },
    {
        path: '/logout',
        name: 'logout',
        // component: () => import(/* webpackChunkName: "about" */ './views/Administraciones.vue'),
        component: login,
        props: true,
    },
    {
      path: '/administraciones',
      name: 'administraciones',
      // component: () => import(/* webpackChunkName: "about" */ './views/Administraciones.vue'),
      component: administraciones,
      // props: true,
    },
    {
      path: '/condominiosSelector',
      name: 'condominiosSelector',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: condominiosSelector,
      props: true,
    },
    {
      path: '/Condominio',
      name: 'condominio',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: condominio,
      props: true,
    },
    {
      path: '/Conceptos',
      name: 'conceptos',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: conceptos,
      props: true,
    },
    {
      path: '/Series',
      name: 'series',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: series,
      props: true,
    },
    {
      path: '/Recibos',
      name: 'recibos',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: recibos,
      props: true,
    },
    {
      path: '/Persistentes',
      name: 'persistentes',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: persistentes,
      props: true,
    },
    {
      path: '/LoteRecibos',
      name: 'loteRecibos',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: loteRecibos,
      props: true,
    },
    {
      path: '/Unidades',
      name: 'unidades',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: unidades,
      // props: true
    },
    {
      path: '/User',
      name: 'user',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: user,
      // props: true
    },
    {
      path: '/Cuentas',
      name: 'cuentas',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: cuentas,
      // props: true
    },
    {
      path: '/Contables',
      name: 'contables',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: contables,
      // props: true
    },
    {
      path: '/Cobros',
      name: 'cobros',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: cobros,
      // props: true
    },
    {
      path: '/NoRIngresos',
      name: 'noringresos',
      // component: () => import(/* webpackChunkName: "about" */ './views/Condominios.vue'),
      component: noringresos,
      // props: true
    },
    {
      path: '/Pagos',
      name: 'pagos',
      component: pagos,
    },
    {
      path: '/Proveedores',
      name: 'proveedores',
      component: proveedores,
    },
    {
      path: '/Egreso',
      name: 'egreso',
      component: egreso,
    },
    {
      path: '/Generar',
      name: 'generar',
      component: generar,
    },

  ],
});
